import { render, staticRenderFns } from "./importarInventario.vue?vue&type=template&id=d4632284&scoped=true&"
import script from "./importarInventario.vue?vue&type=script&lang=js&"
export * from "./importarInventario.vue?vue&type=script&lang=js&"
import style0 from "./importarInventario.vue?vue&type=style&index=0&id=d4632284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4632284",
  null
  
)

export default component.exports